import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface SessionExpiredDialogData {
  reason?: string;
  /** Optional i18n key overriding the default MESSAGE line — used for the
   * session-ending 401 codes (sub-user disabled, account disabled, …). */
  messageKey?: string;
}

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule
  ],
  template: `
    <div class="session-expired-dialog">
      <div class="dialog-icon">
        <mat-icon>lock_clock</mat-icon>
      </div>
      <h2 mat-dialog-title>{{ 'SESSION_EXPIRED_DIALOG.TITLE' | translate }}</h2>
      <mat-dialog-content>
        <p>{{ (data.messageKey || 'SESSION_EXPIRED_DIALOG.MESSAGE') | translate }}</p>
        <p class="sub-text">{{ 'SESSION_EXPIRED_DIALOG.LOGIN_AGAIN' | translate }}</p>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-raised-button color="primary" (click)="close()">
          <mat-icon>login</mat-icon>
          {{ 'SESSION_EXPIRED_DIALOG.LOGIN_BUTTON' | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .session-expired-dialog {
      text-align: center;
      padding: 20px;
    }
    
    .dialog-icon {
      margin-bottom: 16px;
      
      mat-icon {
        font-size: 64px;
        width: 64px;
        height: 64px;
        color: #f44336;
      }
    }
    
    h2 {
      margin: 0 0 16px 0;
      color: #333;
      font-weight: 500;
    }
    
    mat-dialog-content {
      p {
        margin: 0 0 8px 0;
        color: #666;
        font-size: 14px;
        
        &.sub-text {
          color: #999;
          font-size: 13px;
        }
      }
    }
    
    mat-dialog-actions {
      margin-top: 24px;
      
      button {
        min-width: 150px;
        
        mat-icon {
          margin-right: 8px;
        }
      }
    }
  `]
})
export class SessionExpiredDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SessionExpiredDialogComponent>);
  public readonly data: SessionExpiredDialogData = inject(MAT_DIALOG_DATA, { optional: true }) || {};
  
  close(): void {
    this.dialogRef.close();
  }
}
